import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const mailToServiceDeskUrl = `${environment.apiUrl}/mail`;

@Injectable()
export class ServiceDeskService {
  private subject = 'CBM: Melding naar Functioneel Beheer';

  constructor(private readonly httpService: HttpService) {}

  public mailServicedesk(message: string): Observable<Response> {
    const headers = this.httpService.headersWithCredentialsWithoutContentType();
    headers.set('Content-Type', 'application/x-www-form-urlencoded');

    const messageToSend = `subject=${this.subject}&message=${message}`;
    return this.httpService.post(mailToServiceDeskUrl, messageToSend, headers);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/servicedesk.service.ts